"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenLoader = void 0;
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const react_1 = require("@xstate/react");
const react_2 = __importStar(require("react"));
const States_1 = require("../../lib/constants/States");
const styles_1 = require("./styles");
const useWindowWidth_1 = __importDefault(require("../../lib/useWindowWidth"));
const prop_types_1 = require("prop-types");
const xstate_1 = require("xstate");
/**
 * Component for showing loader in full screen.
 *
 * @param {Object} props - The props object.
 * @param {Interpreter} props.service - The xState service object.
 * @param {boolean} props.isRenderingInDrawer - Flag to indicate if direct book is being rendered in a drawer.
 *
 * @returns {JSX.Element}
 */
const FullScreenLoader = ({ service, isRenderingInDrawer, activeState }) => {
    const [state] = (0, react_1.useService)(service);
    const { value, matches } = state;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    (0, react_2.useEffect)(() => {
        if (!matches(activeState) || isRenderingInDrawer) {
            return () => { };
        }
        // Disable scrolling
        document.body.style.overflow = 'hidden';
        // Re-enable scrolling when the component unmounts
        return () => {
            document.body.style.overflow = '';
        };
    }, [value, activeState, isRenderingInDrawer, matches]);
    if (matches(activeState)) {
        return (react_2.default.createElement(styles_1.FullScreenLoaderStyle, { isMobile: !aboveMd, "data-testid": "full-screen-loader" },
            react_2.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, { size: "medium" })));
    }
    return null;
};
exports.FullScreenLoader = FullScreenLoader;
exports.FullScreenLoader.propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    isRenderingInDrawer: prop_types_1.bool,
    activeState: prop_types_1.string
};
exports.FullScreenLoader.defaultProps = {
    isRenderingInDrawer: false,
    activeState: `${States_1.patientForm}.${States_1.bookingAppt}`
};
//# sourceMappingURL=FullscreenLoader.js.map